import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import { Phone, Mail, ArrowUpRight, MapPin } from "lucide-react";
import logo from "./img/slogo.png";

const spaces = [
  { name: "Torchbearer Main", href: "https://torchbearer.co.ke" },
  { name: "Institute", href: "https://institute.torchbearer.co.ke" },
  { name: "eMobility", href: "https://emobility.torchbearer.co.ke" },
  { name: "Greatstar Energy", href: "https://greatstar.torchbearer.co.ke" },
];

function Footer() {
  const socialLinks = [
    { icon: <FaFacebookF />, href: "https://web.facebook.com/p/Torchbearer-Technologies-61553911681911" },
    { icon: <FaLinkedinIn />, href: "https://ke.linkedin.com/company/torchbearer-technologies" },
  ];

  const services = [
    "Solar PV Installation",
    "CCTV & Security Systems",
    "Electrical Wiring & Upgrades",
    "HVAC Installation & Service",
    "Solar Water Heating",
    "Electrical Repairs",
  ];

  return (
    <footer className="relative overflow-hidden" style={{ background: '#2a2118' }}>
      {/* Decorative top bar */}
      <div className="h-0.5 w-full" style={{ background: 'linear-gradient(90deg, transparent, #712B35, #b89b6e, #712B35, transparent)' }} />

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-10 lg:py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">

          {/* Brand */}
          <div>
            <img src={logo} alt="Torchbearer Technologies" className="h-14 w-auto brightness-0 invert" />
            <p className="text-gray-400 mt-3 leading-relaxed text-xs max-w-xs">
              We illuminate spaces with reliable electrical and solar solutions while keeping your safety and comfort first.
            </p>
            <div className="flex gap-2 mt-4">
              {socialLinks.map((s, i) => (
                <a
                  key={i}
                  href={s.href}
                  className="w-9 h-9 rounded-xl flex items-center justify-center text-xs text-gray-400 transition-all duration-300 hover:scale-110 hover:text-white"
                  style={{ background: 'rgba(255,255,255,0.06)' }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#712B35';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(113,43,53,0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.06)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold text-xs tracking-wider uppercase mb-4">Services</h3>
            <ul className="space-y-2">
              {services.map((s, i) => (
                <li key={i}>
                  <span className="text-gray-400 text-xs hover:text-white transition-colors duration-300 cursor-default">
                    {s}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Our Spaces */}
          <div>
            <h3 className="text-white font-semibold text-xs tracking-wider uppercase mb-4">Our Spaces</h3>
            <ul className="space-y-2.5">
              {spaces.map((space, i) => (
                <li key={i}>
                  <a
                    href={space.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-gray-400 text-xs hover:text-white transition-colors duration-300 group"
                  >
                    {space.name}
                    <ArrowUpRight className="w-2.5 h-2.5 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold text-xs tracking-wider uppercase mb-4">Contact</h3>
            <ul className="space-y-2.5">
              <li>
                <a href="tel:+254743076376" className="flex items-center gap-2.5 text-gray-400 text-xs hover:text-white transition-colors duration-300 group">
                  <span className="w-7 h-7 rounded-lg flex items-center justify-center transition-all duration-300 group-hover:scale-110" style={{ background: 'rgba(113,43,53,0.2)' }}>
                    <Phone className="w-3 h-3" style={{ color: '#712B35' }} />
                  </span>
                  +254 743 076376
                </a>
              </li>
              <li>
                <a href="mailto:info@torchbearer.co.ke" className="flex items-center gap-2.5 text-gray-400 text-xs hover:text-white transition-colors duration-300 group">
                  <span className="w-7 h-7 rounded-lg flex items-center justify-center transition-all duration-300 group-hover:scale-110" style={{ background: 'rgba(113,43,53,0.2)' }}>
                    <Mail className="w-3 h-3" style={{ color: '#712B35' }} />
                  </span>
                  info@torchbearer.co.ke
                </a>
              </li>
              <li className="flex items-center gap-2.5 text-gray-400 text-xs">
                <span className="w-7 h-7 rounded-lg flex items-center justify-center" style={{ background: 'rgba(113,43,53,0.2)' }}>
                  <MapPin className="w-3 h-3" style={{ color: '#712B35' }} />
                </span>
                Kiambu, Kenya
              </li>
            </ul>
            <a
              href="/contact"
              className="inline-flex items-center gap-1.5 text-xs font-semibold text-white mt-4 px-4 py-2.5 rounded-xl transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5"
              style={{ background: '#712B35' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#5f2b40';
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(113,43,53,0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#712B35';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              Get a Quote
              <ArrowUpRight className="w-3 h-3" />
            </a>
          </div>
        </div>

        {/* Location - Full width */}
        <div className="mt-8 pt-8" style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}>
          <h3 className="text-white font-semibold text-xs tracking-wider uppercase mb-4">Location</h3>
          <div className="overflow-hidden rounded-xl" style={{ border: '1px solid rgba(255,255,255,0.08)' }}>
            <iframe
              title="Torchbearer location map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.948281358941!2d36.8218421!3d-1.162143!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f3dd37ed17fc9%3A0xf13f5dc26681d!2sTORCHBEARER+TECHNOLOGIES!5e0!3m2!1sen!2ske!4v1700000000000"
              width="100%"
              height="220"
              style={{ border: 0, display: 'block' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-8 pt-5 flex flex-col md:flex-row justify-between items-center gap-3" style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}>
          <p className="text-xs text-gray-500">
            &copy; {new Date().getFullYear()} Torchbearer Technologies. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-gray-500">
            <button className="hover:text-white transition-colors cursor-pointer">Privacy</button>
            <button className="hover:text-white transition-colors cursor-pointer">Terms</button>
            <span className="text-gray-600">|</span>
            <a href="https://www.garikon.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors flex items-center gap-1">
              Site by Garikon
              <ArrowUpRight className="w-2.5 h-2.5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
